import React, { ReactNode } from 'react';
import './MarketplaceOverlay.css';

interface MarketplaceOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

export const MarketplaceOverlay: React.FC<MarketplaceOverlayProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="marketplace-overlay-backdrop" onClick={onClose}>
      <div className="marketplace-overlay-container" onClick={(e) => e.stopPropagation()}>
        <button className="marketplace-overlay-close" onClick={onClose}>
          ✕
        </button>
        <div className="marketplace-overlay-content">
          {children}
        </div>
      </div>
    </div>
  );
};
